function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xffd9da;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;


    var itemsPositionsObject = { d0_4: { x: 240, y: 256, w: 38, h: 38, n: "d0_4" }, d0_3: { x: 106, y: 312, w: 38, h: 38, n: "d0_3" }, d0_2: { x: 165, y: 118, w: 38, h: 38, n: "d0_2" }, d0_1: { x: 196, y: 65, w: 38, h: 38, n: "d0_1" }, d0_0: { x: 228, y: 21, w: 38, h: 38, n: "d0_0" }, bg_0: { x: 0, y: 0, w: 861, h: 495, n: "bg_0" }, d1_4: { x: 272, y: 324, w: 38, h: 38, n: "d1_4" }, d1_3: { x: 74, y: 223, w: 38, h: 38, n: "d1_3" }, d1_2: { x: 248, y: 189, w: 38, h: 38, n: "d1_2" }, d1_1: { x: 328, y: 180, w: 38, h: 38, n: "d1_1" }, d1_0: { x: 354, y: 147, w: 38, h: 38, n: "d1_0" }, bg_1: { x: 0, y: 0, w: 861, h: 495, n: "bg_1" }, d2_4: { x: 169, y: 233, w: 38, h: 38, n: "d2_4" }, d2_3: { x: 191, y: 296, w: 38, h: 38, n: "d2_3" }, d2_2: { x: 277, y: 224, w: 38, h: 38, n: "d2_2" }, d2_1: { x: 219, y: 154, w: 38, h: 38, n: "d2_1" }, d2_0: { x: 277, y: 51, w: 38, h: 38, n: "d2_0" }, bg_2: { x: 0, y: 0, w: 861, h: 495, n: "bg_2" } };

    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);
        document.addEventListener('stopGame', onStopGame, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function onStartGame() {

    }

    function onStopGame() {
        end();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 1600);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {


        gameData.numItems = 5;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(300, 36);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('gioco', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        // if (gameData.numItems > 1) {
        game.gameContainer.addChild(counter.container);
        //  }

    }


    function positionGameItems() {

        sprites.btn_gioca.x = 1051;
        sprites.btn_gioca.y = 453;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        //  gameData.currentItem++;
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;
    var levels = {};

    levels.level_0 = {
        numdiffs: 5,
        container: new Container()
    };

    levels.level_1 = {
        numdiffs: 5,
        container: new Container()
    };

    levels.level_2 = {
        numdiffs: 5,
        container: new Container()
    };

    var interactiveExceptionalPositions = {
        d0_1: [186, 73, 205, 108, 234, 95, 246, 74],
        d0_4: [213, 228, 195, 282, 262, 317, 310, 239, 282, 200, 248, 268],
        d1_4: [242, 309, 315, 383, 331, 368, 282, 305],
        d1_3: [13, 253, 44, 218, 162, 240, 151, 260, 55, 266, 22, 306],
        d1_2: [186, 178, 278, 169, 314, 248, 286, 249],
    };

    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var buttonsContainer;


    var gameIndex = 0;
    var sceneElements = {};
    var levelNames = ['0', '1', '2'];

    var currentLevelData;
    var currentLevelContainer;
    var currentLevelName;
    var found;



    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);


    initScene();

    function initScene() {
        var i, ii, iii;
        var poly;
        var specularPoly;
        var spriteItem;
        var pos;
        var bgpos;

        for (i = 0; i < 3; i++) {
            currentLevelName = levelNames[i];
            currentLevelData = levels['level_' + currentLevelName];
            currentLevelContainer = currentLevelData.container;
            container.addChild(currentLevelContainer);
            buttonsContainer = new Container();
            sceneElements['buttonsContainer_' + currentLevelName] = buttonsContainer;

            buttonsContainer.interactive = true;
            // spriteItem.buttonMode = true;
            buttonsContainer.on('pointertap', onClick);

            spriteItem = game.sprites['bg_' + currentLevelName];
            bgpos = positions['bg_' + currentLevelName];
            spriteItem.position.set(bgpos.x, bgpos.y);
            currentLevelContainer.addChild(spriteItem);
            sceneElements['bg_' + currentLevelName] = spriteItem;

            for (ii = 0; ii < currentLevelData.numdiffs; ii++) {
                pos = positions['d' + currentLevelName + '_' + ii];
                spriteItem = new Sprite(game.sprites.bollo_selezione.texture);
                spriteItem.interactive = false;
                spriteItem.position.set(pos.x, pos.y);
                currentLevelContainer.addChild(spriteItem);
                sceneElements['d' + currentLevelName + '_' + ii] = spriteItem;

                spriteItem = new Sprite(game.sprites.bollo_selezione.texture);
                spriteItem.position.set(bgpos.w - pos.x - pos.w, pos.y);
                currentLevelContainer.addChild(spriteItem);
                sceneElements['dr' + currentLevelName + '_' + ii] = spriteItem;

                spriteItem = new Graphics();

                spriteItem.beginFill(0x000000);
                spriteItem.lineStyle(0, 0x000000);

                if (interactiveExceptionalPositions['d' + currentLevelName + '_' + ii]) {
                    poly = interactiveExceptionalPositions['d' + currentLevelName + '_' + ii];
                    specularPoly = [];

                    for (var p = 0; p < poly.length; p++) {

                        specularPoly.push((p % 2 == 1) ? poly[p] : bgpos.w - poly[p]);
                    }
                    spriteItem.drawPolygon(poly);
                    spriteItem.drawPolygon(specularPoly);
                } else {
                    spriteItem.drawRect(pos.x, pos.y, pos.w, pos.h);
                    spriteItem.drawRect(bgpos.w - pos.x - pos.w, pos.y, pos.w, pos.h);
                }
                spriteItem.endFill();
                spriteItem.name = ii;
                spriteItem.interactive = true;
                spriteItem.buttonMode = false;
                spriteItem.alpha = 0;
                buttonsContainer.addChild(spriteItem);

                sceneElements['b_' + currentLevelName + '_' + ii] = spriteItem;

            }


            currentLevelContainer.alpha = 0;
            currentLevelContainer.addChild(buttonsContainer);

        }


    }


    function clear() {


    }

    function reset() {
        // levelNames = _.shuffle(levelNames);
        gameIndex = 0;
        setState('newLevel');
    }

    function resetLevels() {
        var i, ii, iii;

        for (i = 0; i < levelNames.length; i++) {
            currentLevelName = levelNames[i];
            currentLevelData = levels['level_' + currentLevelName];
            currentLevelContainer = currentLevelData.container;
            currentLevelContainer.alpha = 0;

            sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = false;
            sceneElements['buttonsContainer_' + currentLevelName].interactive = false;
            for (ii = 0; ii < currentLevelData.numdiffs; ii++) {


                sceneElements['b_' + currentLevelName + '_' + ii].interactive = true;
                sceneElements['d' + currentLevelName + '_' + ii].alpha = 0;
                sceneElements['dr' + currentLevelName + '_' + ii].alpha = 0;

            }
        }
        found = 0;
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newLevel':
                resetLevels();


                levelNames.push(levelNames.shift());

                currentLevelName = levelNames[0];
                currentLevelData = levels['level_' + currentLevelName];
                sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = true;
                sceneElements['buttonsContainer_' + currentLevelName].interactive = true;
                currentLevelContainer = currentLevelData.container;
                currentLevelContainer.interaciveCildren = true;
                currentLevelContainer.alpha = 1;

                break;
            case 'ready':
                loopSequence = [renderOnce];
                break;
            case 'animating':


                break;
        }
        currentState = state;

    }




    function onClick(e) {

        if (currentState === "ready") {


            var clicked = e.target.name.toString();

            if (clicked) {
                sceneElements['d' + currentLevelName + '_' + clicked].alpha = 1;
                sceneElements['dr' + currentLevelName + '_' + clicked].alpha = 1;
                sceneElements['b_' + currentLevelName + '_' + clicked].interactive = false;
                loopSequence = [renderOnce];
                renderer.view.dispatchEvent(new Event('answerOk'));
                setTimeout(okComplete, 800);
            }

        }

    }



    function okComplete() {

        theGame.cycleGame();


    }

}